import React, { useState, useRef, useEffect } from "react";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { playMessage, stopAudio, getPlayState } from "./api";
import { analyser, filterText } from "./utils";
import {
  moduleConfig,
  asrParams,
  closeWordList,
  aiDigitalTypeChangeitems,
  DigitalTypeConfig,
} from "./config";
import stopIcon from "../../static/stop.svg";
import closeIcon from "../../static/close.svg";
import startIcon from "../../static/start.svg";
import clearIcon from "../../static/clear.svg";
import { SrsRtcWhipWhepAsync } from "./srs.sdk";
import { useVirtualHuman } from "./useVirtualHuman";
import { useGreet } from "./components/useGreet";
import ModalSelect from "./components/modeSelect";
import ChatList from "./components/chatList";
import Header from "./components/header";
import ActiveBtn from "./components/activeBtn";
import "./index.less";

let errorCount = 0;

var sdk = null;

// ASR对象
let webAudioSpeechRecognizer;
// ASR识别结果
let recordingStr = "";

// 全局状态
const globalStatus = {
  isInitAnalyser: false,
  audioStream: null,
};

function Index() {
  const {
    chatList,
    isStreaming,
    resetList,
    addNullMessage,
    setLastMessageText,
    setPendingText,
    setLockTextState,
    clearNullMessage,
  } = useVirtualHuman();

  const answerRef = useRef("");

  const [currentDigitalType, setCurrentDigitalType] = useState(
    aiDigitalTypeChangeitems[0].value
  );

  const digitalConfig = useRef(
    DigitalTypeConfig[aiDigitalTypeChangeitems[0].value]
  );

  const [lastMessageId, setLastMessageId] = useState(""); // 模型记录上下文id
  const [, setCountdownTime] = useState(15); // 未录音倒计时，归0后自动暂停录音

  const [isAiEnabled, setIsAiEnabled] = useState(false); // 开启问答｜关闭问答 显示状态

  const [digitalChangeShow, setDigitalChangeShow] = useState(false);
  const [digitalChangeOpen, setDigitalChangeOpen] = useState(false);

  const [playStatus, setPlayStatus] = useState("over"); // 播报状态: over:播放结束  ｜ start:播放中 用于Effect

  const [isPlaying, setIsPlaying] = useState(false); // 播放中状态 用于展示
  const isPlayingRef = useRef(false); // 播放状态 用于即时控制

  const [isRecording, setIsRecording] = useState(false); // 录音状态 用于展示
  const isRecordingRef = useRef(false); // 录音状态 用于即时控制

  const messageManualPlayStatus = useRef(true); // 手动控制是否播报

  const isActive = useRef(false); // 当前开启｜关闭状态

  const unchangedTimer = useRef(); // 录音后的文字2秒没变化时直接发送的计时器

  const { GreetVideo, startGreetTime, resetGreetTime } = useGreet(
    moduleConfig.greet
  );

  // 音波所用
  const asrPopElt = useRef();
  const waveLeft = useRef();
  const waveRight = useRef();

  const currentRecordingText = useRef(""); // 当前正在录音的文本
  const isInGenStatus = useRef(false); // 判断当前是否是生成中的状态

  const rtcMediaPlayer = useRef({}); // 媒体节点Ref

  const isEnter = useRef(true); // 是否初次进入页面

  // 初始化
  useEffect(() => {
    initRecord();
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
      stopAudio(digitalConfig.current.api);
    };
    const contextmenuHandle = (e) => {
      e.preventDefault();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    document.addEventListener("contextmenu", contextmenuHandle);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("contextmenu", contextmenuHandle);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 开启/关闭
  useEffect(() => {
    if (isEnter.current) {
      if (moduleConfig.greet) {
        startGreetTime();
      }
      return;
    }

    if (!isAiEnabled) {
      if (moduleConfig.modeChange) {
        setDigitalChangeOpen(false);
      }
      if (moduleConfig.greet) {
        startGreetTime();
      }
    } else {
      if (moduleConfig.modeChange) {
        setDigitalChangeOpen(true);
      }

      if (moduleConfig.greet) {
        resetGreetTime();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAiEnabled]);

  useEffect(() => {
    resetList();
    setLastMessageId("");
    if (!currentDigitalType) {
      return;
    }
    if (!DigitalTypeConfig[currentDigitalType]) {
      return;
    }

    digitalConfig.current = DigitalTypeConfig[currentDigitalType];
    initDigitl();

    if (!isActive.current) {
      return;
    }

    closeHandle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDigitalType]);

  useEffect(() => {
    if (!isRecording) {
      return;
    }
    let timer;
    setCountdownTime(15);
    timer = setInterval(() => {
      setCountdownTime((oldValue) => {
        if (oldValue <= 0) {
          closeHandle();
        }
        return oldValue - 1;
      });
    }, 1000);

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRecording]);

  useEffect(() => {
    if (playStatus === "over") {
      return;
    }
    let isStart = false;

    rtcMediaPlayer.current.muted = false;
    const queueGetState = async () => {
      const res = await getPlayState(digitalConfig.current.api);
      if (res?.code === 0) {
        let data = res?.message;
        if (data.tts_state === 0) {
          // 播报中
          isStart = true;
          setTimeout(() => {
            setIsPlaying(() => {
              const ip =
                messageManualPlayStatus.current &&
                !isRecordingRef.current &&
                isActive.current;
              return ip;
            });
          }, 1000);

          isPlayingRef.current = true;
          setTimeout(() => {
            if (messageManualPlayStatus.current && isActive.current) {
              queueGetState();
            }
          }, 500);
        } else if (data.tts_state === 1 && isStart === false) {
          if (messageManualPlayStatus.current && isActive.current) {
            setTimeout(() => {
              queueGetState();
            }, 500);
          }
        } else {
          setTimeout(() => {
            if (messageManualPlayStatus.current) {
              setPlayStatus("over");
              setIsPlaying(false);
              isPlayingRef.current = false;
              isActive.current = true;
              console.log("debug-状态为1-开始录音");
              startRecord("dynamic");
            }
          }, 1200);
        }
      }
    };
    setTimeout(() => {
      if (messageManualPlayStatus.current && isActive.current) {
        queueGetState();
      }
    }, 1000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playStatus]);

  useEffect(() => {
    if (playStatus === "over") {
      return;
    }

    const queueGetState = async () => {
      const res = await getPlayState(digitalConfig.current.api);
      if (res?.code === 0) {
        let data = res?.message;
        // 播报中
        if (
          data.tts_state === 0 &&
          messageManualPlayStatus.current &&
          !isRecordingRef.current &&
          isActive.current
        ) {
          setLockTextState(true);
          setIsPlaying(true);
        } else {
          if (
            !isRecordingRef.current &&
            messageManualPlayStatus.current &&
            isActive.current
          ) {
            setTimeout(() => {
              queueGetState();
            }, 500);
          }
        }
      }
    };

    queueGetState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playStatus]);

  useEffect(() => {
    if (isEnter.current) {
      return;
    }

    if (
      !isStreaming &&
      !messageManualPlayStatus.current &&
      !isRecordingRef.current
    ) {
      console.log("debug-输出完毕-开始录音");
      startRecord("dynamic");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStreaming]);

  useEffect(() => {
    if (isRecording) {
      asrPopElt.current.style.bottom = "2vh";
      if (!globalStatus.isInitAnalyser) {
        analyser(waveLeft, false, globalStatus);
        analyser(waveRight, true, globalStatus);
        globalStatus.isInitAnalyser = true;
      }
    } else {
      asrPopElt.current.style.bottom = "-20vh";
    }
  }, [isRecording]);

  const onRecordingEndHandle = () => {
    if (
      webAudioSpeechRecognizer &&
      typeof webAudioSpeechRecognizer.stop === "function"
    ) {
      webAudioSpeechRecognizer.stop();
      webAudioSpeechRecognizer = {};
    }
    console.log("debug-准备发送了");
    recordingStr += currentRecordingText.current;

    // if (recordingStr === "嗯。") {
    //   deleteLastMessage();
    //   startRecord("dynamic");
    //   return;
    // }

    console.log(recordingStr, "recordingStr");

    if (recordingStr && messageManualPlayStatus.current) {
      setIsRecording(false);
      isRecordingRef.current = false;
      setLastMessageText(recordingStr);
      sendHandle(recordingStr);

      setTimeout(() => {
        recordingStr = "";
        currentRecordingText.current = "";
      }, 300);
    }
    setTimeout(() => {
      recordingStr = "";
      currentRecordingText.current = "";
    }, 300);
  };

  const startRecordStatus = () => {
    setIsAiEnabled(true);
    setIsRecording(true);
    isActive.current = true;
    isRecordingRef.current = true;
  };

  function startRecord(type) {
    setTimeout(() => {
      clearNullMessage();
    }, 300);
    if (
      webAudioSpeechRecognizer &&
      typeof webAudioSpeechRecognizer.stop === "function"
    ) {
      webAudioSpeechRecognizer.stop();
      webAudioSpeechRecognizer = {};
    }

    if (unchangedTimer.current) {
      clearInterval(unchangedTimer.current);
    }

    if (type === "dynamic") {
      startRecordStatus();
    }

    currentRecordingText.current = "";
    recordingStr = "";

    setTimeout(() => {
      if (rtcMediaPlayer?.current) {
        rtcMediaPlayer.current.muted = true;
      }
    }, 1000);

    let unchangedTimeCount = 2; // 语音识别超过3秒没输入则发送当前内容

    // 关闭语音唤起
    if (type === "static") {
      return;
    }

    console.log(type, "开启了录音");
    isEnter.current = false;
    webAudioSpeechRecognizer = new window.WebAudioSpeechRecognizer(asrParams);

    webAudioSpeechRecognizer.OnRecognitionStart = (res) => {
      console.log("开始识别", type);
    };

    webAudioSpeechRecognizer.OnSentenceBegin = (res) => {
      if (type === "dynamic") {
        console.log("一句话开始");
        addNullMessage("send");
      }
    };

    // 识别变化时
    webAudioSpeechRecognizer.OnRecognitionResultChange = (res) => {
      if (!isActive.current || type === "static") {
        console.log("debug-已经关闭了-不继续收音并清空已收音内容");
        currentRecordingText.current = "";
        recordingStr = "";
        return;
      }
      currentRecordingText.current = recordingStr + res?.result.voice_text_str;

      console.log(currentRecordingText.current, "正在说的语音");

      setLastMessageText(recordingStr + res?.result.voice_text_str);
      unchangedTimeCount = 2;
      if (unchangedTimer.current) {
        clearInterval(unchangedTimer.current);
      }
      unchangedTimer.current = setInterval(() => {
        if (!isRecordingRef.current) {
          console.log("debug - 已经发送过了 - 清空定时器");
          clearInterval(unchangedTimer.current);
          return;
        }

        if (unchangedTimeCount <= 0) {
          console.log("debug - 3秒自动发送");
          messageManualPlayStatus.current = true;
          onRecordingEndHandle();
          clearInterval(unchangedTimer.current);
          return;
        }
        console.log(unchangedTimeCount, "unchangedTimeCount");
        unchangedTimeCount -= 1;
      }, 1000);
      setCountdownTime(15);
    };

    // 一句话结束
    webAudioSpeechRecognizer.OnSentenceEnd = (res) => {
      if (!isActive.current || type === "static" || !isRecordingRef.current) {
        console.log("debug-已经关闭了-不继续发送消息并清空已收音内容");
        currentRecordingText.current = "";
        recordingStr = "";
        return;
      }

      currentRecordingText.current = res?.result.voice_text_str;
      console.log(currentRecordingText.current, type, "正在说的语音-结束");
      messageManualPlayStatus.current = true;
      const pattern = new RegExp(
        `^(?=.*(?:${closeWordList.join("|")}))(?=^.{1,8}$)`
      );
      if (pattern.test(currentRecordingText.current)) {
        closeHandle();
        currentRecordingText.current = "";
        return;
      }
      messageManualPlayStatus.current = true;
      console.log("debug - 一句话结束");
      onRecordingEndHandle();
    };

    // 识别结束
    webAudioSpeechRecognizer.OnRecognitionComplete = (res) => {
      console.log("识别结束", res);
    };

    // 识别错误
    webAudioSpeechRecognizer.OnError = (res) => {
      console.log("识别错误", res);
      if (errorCount <= 5) {
        setTimeout(() => {
          errorCount += 1;
          startRecord(type);
        }, 2000);
      }
    };
    webAudioSpeechRecognizer.start();
  }

  // init音频
  const initRecord = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({
          audio: true,
          video: false,
          audioTrackSet: {
            deviceId: "",
            groupId: "",
            echoCancellation: false,
            noiseSuppression: false,
          },
        })
        .then((stream) => {
          globalStatus.audioStream = stream;
          globalStatus.audioCtx = new (window.AudioContext ||
            window.webkitAudioContext)();
          startRecord("static");
        })
        ["catch"](function (e) {
          console.log("没有获得麦克风权限!请允许使用麦克风权限后刷新页面重试!");
          console.error("media error:", e);
        });
    } else {
      if (
        navigator.userAgent.toLowerCase().match(/chrome/) &&
        window.location.origin.indexOf("https://") < 0
      ) {
        console.log(
          "chrome下获取浏览器录音功能，因为安全性问题，需要在localhost或127.0.0.1或https下才能获取权限"
        );
      } else {
        console.log("无法获取浏览器录音功能，请升级浏览器或使用chrome");
      }
    }
  };

  const sendHandle = (sendMessage) => {
    messageManualPlayStatus.current = true;
    answerRef.current = "";

    isPlayingRef.current = true;

    clearNullMessage();

    setPendingText("");
    setLockTextState(false);

    const englishPattern = /^[a-zA-Z0-9\s\p{P}]+$/u;

    if (englishPattern.test(sendMessage)) {
      addNullMessage();

      playMessage(
        `${digitalConfig.current.defaultMessage}很抱歉，您提出的问题目前超出了我的服务范围。为了更好地帮助您，我建议您可以通过其他渠道或直接联系我们的工作人员获取所需信息。如有其他问题，欢迎随时向我咨询。`,
        digitalConfig.current.api
      ).then((res) => {
        isPlayingRef.current = true;
        setPlayStatus("start");
        setPendingText(
          `${digitalConfig.current.defaultMessage}很抱歉，您提出的问题目前超出了我的服务范围。为了更好地帮助您，我建议您可以通过其他渠道或直接联系我们的工作人员获取所需信息。如有其他问题，欢迎随时向我咨询。`
        );
      });
      return;
    }

    const data = {
      inputs: {
        query: "你是黑马天启政策解读智能体。",
      },
      user: "aGVpbWF0aWFucWlfamlhb2Z1X2d1b3dhbmdfMjAyNDA0Mjk",
      response_mode: "streaming",
      query: sendMessage,
      conversation_id: lastMessageId,
    };

    let messageCount = 0; // 用作判断处理接口返回是否是一整段文本引起的问题
    let tmpParagraphText = ""; // 给数字人格式化后的播报文本
    let longText = "";

    setTimeout(() => {
      setCountdownTime(15);
    }, 5000);

    addNullMessage();

    let imageUrl = "";
    let isHaveImage = false;
    try {
      fetchEventSource("https://base17.heimatianqi.com/v1/chat-messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/event-stream",
          Authorization: digitalConfig.current.key,
        },
        body: JSON.stringify(data),
        openWhenHidden: true,
        onmessage(ev) {
          if (ev.event !== "ping" && ev !== "ping" && ev.data !== "ping") {
            let analysisData = JSON.parse(ev.data || "{}");

            if (
              isActive.current === false ||
              messageManualPlayStatus.current === false
            ) {
              throw Error("手动打断");
            }

            if (
              analysisData.event === "message_end" &&
              messageCount === 1 &&
              messageManualPlayStatus.current
            ) {
              playMessage(answerRef.current, digitalConfig.current.api).then(
                (res) => {
                  isPlayingRef.current = true;
                  setPlayStatus("start");
                }
              );
              setLastMessageId(analysisData.conversation_id);
              messageCount = 0;
              return;
            }

            if (
              analysisData.event === "message" ||
              analysisData.event === "agent_message"
            ) {
              messageCount += 1;
              answerRef.current = answerRef.current + analysisData.answer;

              isInGenStatus.current = true;

              // 减少pendingText更新次数，防止卡顿。
              if (answerRef.current.length % 30 === 0) {
                setPendingText(answerRef.current);
              }

              setLastMessageId(analysisData.conversation_id);

              if (messageManualPlayStatus.current) {
                if (imageUrl || analysisData.answer.includes("!")) {
                  imageUrl += analysisData.answer;
                  if (imageUrl.length >= 10 && !imageUrl.includes(`![image]`)) {
                    imageUrl = "";
                  } else if (
                    imageUrl.length >= 10 &&
                    imageUrl.includes("![image]")
                  ) {
                    isHaveImage = true;
                    if (analysisData.answer.includes(")")) {
                      console.log(imageUrl, "图片的地址哈哈");
                      imageUrl = "";
                      isHaveImage = false;
                    }
                  }
                }

                if (isHaveImage) {
                  return;
                }

                const { text, canEnd } = filterText(analysisData.answer);
                setCountdownTime(() => 15);
                if (!canEnd) {
                  tmpParagraphText += text;
                } else {
                  if (tmpParagraphText) {
                    const currentLongText = longText + tmpParagraphText;

                    if (
                      currentLongText.length < 60 &&
                      Number.isNaN(parseInt(tmpParagraphText))
                    ) {
                      longText += "," + tmpParagraphText;
                    } else if (
                      currentLongText.length < 3 &&
                      !Number.isNaN(parseInt(tmpParagraphText))
                    ) {
                      longText += tmpParagraphText + ",";
                    } else {
                      if (messageManualPlayStatus.current) {
                        setPlayStatus("start");
                        playMessage(
                          longText.replace(/image/g, ""),
                          digitalConfig.current.api
                        ).then((res) => {
                          if (res && messageManualPlayStatus.current) {
                            // setPlayStatus("start");
                            isPlayingRef.current = true;
                          }
                        });
                      }

                      longText = tmpParagraphText;
                    }
                  }
                  tmpParagraphText = "";
                }
              }
            }
          }
        },
        onclose() {
          if (messageManualPlayStatus.current) {
            setPendingText(answerRef.current);
          }
          if (longText && messageManualPlayStatus.current) {
            playMessage(
              longText.replace(/image/g, ""),
              digitalConfig.current.api
            ).then(() => {
              isPlayingRef.current = true;
              setPlayStatus("start");
            });
            longText = "";
          }
        },
        onerror(error) {
          if (!isActive.current) {
            messageManualPlayStatus.current = true;
          }
          isInGenStatus.current = false;
          console.log("error", error);
          throw error;
        },
      }).catch((err) => {
        isInGenStatus.current = false;
        console.log("手动打断", err);
      });
    } catch (err) {
      isInGenStatus.current = false;
      console.error("错误", err);
      if (!isActive.current) {
        messageManualPlayStatus.current = true;
      }
    }
  };

  const breakHandle = () => {
    setLockTextState(false);
    rtcMediaPlayer.current.muted = true;
    messageManualPlayStatus.current = false;
    setPlayStatus("over");
    stopAudio(digitalConfig.current.api);
    setIsPlaying(false);
    setIsRecording(false);

    setTimeout(() => {
      startRecord("dynamic");
    }, 300);
  };

  const closeHandle = () => {
    // 清空数字人所有状态
    messageManualPlayStatus.current = false;
    setIsPlaying(false);
    setIsRecording(false);
    setIsAiEnabled(false);
    isActive.current = false;
    clearNullMessage();
    setLastMessageId("");
    // 静音
    rtcMediaPlayer.current.muted = true;
    // 停止文本输出
    setLockTextState(false);

    setPlayStatus("over");

    setTimeout(() => {
      clearNullMessage();
    }, 100);
    stopAudio(digitalConfig.current.api);
    setTimeout(() => {
      startRecord("static");
    }, 500);
  };

  function initDigitl() {
    sdk?.close();
    sdk = {};
    sdk = new SrsRtcWhipWhepAsync();
    try {
      rtcMediaPlayer.current.srcObject = sdk?.stream;
    } catch (err) {
      console.log(err, "err");
    }
    const url = `${digitalConfig.current.videoApi}/rtc/v1/whep/?app=live&stream=livestream`;

    try {
      sdk
        .play(url)
        .then(function () {
          rtcMediaPlayer.current.play();
        })
        .catch(function () {
          sdk.close();
        });
    } catch (err) {
      console.error(err, "sdk-play-error");
    }
  }

  return (
    <div
      className="AiDigitalBox"
      onContextMenu={(e) => {
        e.preventDefault();
      }}
    >
      <Header currentDigitalType={currentDigitalType} />
      <div className="AiDigitalBtnGroup">
        <ActiveBtn
          fixed
          icon={clearIcon}
          show={!isAiEnabled && !digitalChangeShow}
          onClick={resetList}
        >
          一键清屏
        </ActiveBtn>
        <ActiveBtn
          icon={startIcon}
          show={!isAiEnabled && !digitalChangeShow}
          onClick={() => {
            startRecord("dynamic");
          }}
        >
          开启问答
        </ActiveBtn>
        <ActiveBtn
          icon={closeIcon}
          show={isAiEnabled && !digitalChangeShow}
          onClick={closeHandle}
        >
          关闭问答
        </ActiveBtn>

        <ActiveBtn
          icon={stopIcon}
          show={isPlaying && !digitalChangeShow}
          onClick={() => {
            breakHandle();
          }}
        >
          停止播报
        </ActiveBtn>
        {moduleConfig.modeChange && (
          <ModalSelect
            value={currentDigitalType}
            onChange={(v) => {
              setCurrentDigitalType(v);

              startRecord("static");
            }}
            show={digitalChangeShow}
            setShow={(dcs) => {
              setDigitalChangeShow(dcs);
            }}
            open={digitalChangeOpen}
            setOpen={(dcs) => {
              setDigitalChangeOpen(dcs);
            }}
          />
        )}
      </div>

      <div className="AiDigitalBox">
        <div id="AiDigitalHuman" className="AiDigitalHuman">
          <video
            ref={rtcMediaPlayer}
            style={{ height: "100vh", width: "100vw" }}
            muted
            onContextMenu={(event) => {
              event.preventDefault();
            }}
          ></video>
        </div>
        <ChatList list={chatList} />
      </div>

      {moduleConfig.greet && <GreetVideo />}

      <div id="asr-pop" className="AiDigitalHumanAsrPop" ref={asrPopElt}>
        <div id="asr-wave">
          <canvas
            id="wave-left"
            style={{ height: "4vh", width: "50vw" }}
            ref={waveLeft}
          ></canvas>
          <canvas
            id="wave-right"
            style={{ height: "4vh", width: "50vw" }}
            ref={waveRight}
          ></canvas>
        </div>
      </div>
    </div>
  );
}

export default Index;
